import { Button } from "@jhool-io/fe-components";
import CheckPaymentSuccess from "../../../../components/Icons/CheckPaymentSuccess";
import ErrorInfoIcon from "../../../../components/Icons/ErrorInfo";

interface PaymentLinkStatusDialogProps {
    variant: "success" | "error";
    description: string;
    buttonText: string;
    onButtonClick: () => void;
}

export default function PaymentLinkStatus({
    variant,
    description,
    buttonText,
    onButtonClick,
}: PaymentLinkStatusDialogProps) {
    return (
        <div className="flex flex-col items-center justify-center px-4">
            <div
                className={
                    variant === "success" ? "flex justify-center mb-2" : ""
                }
            >
                {variant === "success" ? (
                    <CheckPaymentSuccess />
                ) : (
                    <div className="rounded-full bg-danger/10 flex items-center justify-center mx-auto">
                        <ErrorInfoIcon />
                    </div>
                )}
            </div>
            <p className="text-sm text-gray mb-6 text-center">{description}</p>
            <Button
                variant="primary"
                className="w-full"
                onClick={onButtonClick}
            >
                {buttonText}
            </Button>
        </div>
    );
}
